import {AgentServiceFactory} from '../factory/agentservice.factory';
import {AgentService} from '../service/agent.service';
import {RequestService} from '../service/request.service';
import {SessionService} from '../service/session.service';
import {UserService} from '../service/user.service';

export let AgentServiceProvider = {
  provide: AgentService,
  useFactory: AgentServiceFactory,
  deps: [RequestService, UserService, SessionService]
};



// WEBPACK FOOTER //
// ./src/app/shared/provider/agentservice.provider.ts